module.exports = __webpack_public_path__ + "static/media/how_1xxxhdpi.60014822.png";